import React from 'react'
import { observer } from 'mobx-react-lite'

import { StoreScreenTabs, StoreScreenTabsBaseProps } from './StoreScreenTabs'

import { useStore } from '../hooks/storeHook'

import { makeWbAccountName } from '../common/accountUtils'

import { WbAccountModel } from '../server/mpsklad_core/Models/WbAccountModel'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export type WbScreenTabsProps = StoreScreenTabsBaseProps<WbAccountModel>

export const WbScreenTabs =
  observer(
    ({canAddAccount, ...props}: WbScreenTabsProps) => {
      const {canAddWbAccount, syncStore: {wbAccounts}} = useStore()

      return <StoreScreenTabs
        storeType={IntegrationType.Wildberries}
        storeAccounts={wbAccounts}
        canAddAccount={canAddAccount && canAddWbAccount}
        makeAccountName={makeWbAccountName}
        {...props}
      />
    })